export function formatBytes(bytes) {
  const n = Number(bytes) || 0;
  const GB = 1024 ** 3;
  const MB = 1024 ** 2;
  if (n >= 1024 * GB) return `${(n / (1024 * GB)).toFixed(n % (1024 * GB) === 0 ? 0 : 1)} TB`;
  if (n >= GB) return `${(n / GB).toFixed(n % GB === 0 ? 0 : 1).replace(".", ",")} GB`;
  if (n >= MB) return `${(n / MB).toFixed(n % MB === 0 || n >= 100 * MB ? 0 : 1).replace(".", ",")} MB`;
  if (n >= 1024) return `${Math.round(n / 1024)} KB`;
  return `${n} B`;
}

export function initials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function firstName(name) {
  return String(name || "").trim().split(/\s+/)[0] || "";
}

/** "1.250,00 €" senza Intl (vedi la stessa scelta su gestionale-gls). */
export function formatEuro(amount, { decimals = false } = {}) {
  if (amount == null || !Number.isFinite(Number(amount))) return "";
  const [int, dec] = Number(amount).toFixed(2).split(".");
  const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${!decimals && dec === "00" ? intFmt : `${intFmt},${dec}`} €`;
}

/** 1234.5 → "1.234,5" (numeri nelle tabelle). */
export function formatNumero(n, decimali = 0) {
  if (n == null || !Number.isFinite(Number(n))) return "";
  const [int, dec] = Number(n).toFixed(decimali).split(".");
  const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return dec && Number(dec) !== 0 ? `${intFmt},${dec.replace(/0+$/, "")}` : intFmt;
}

/** Minuti → "8:00" (durate), come le salva il modal di gestionale-gls. */
export function formatOre(minuti) {
  const m = Math.max(0, Math.round(Number(minuti) || 0));
  return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`;
}

export function pluralize(n, one, many) {
  return `${n} ${n === 1 ? one : many}`;
}

/** Tipo di file per icona ed etichetta. */
export function fileKind(file) {
  const name = String(file?.nome || file?.name || "").toLowerCase();
  const mime = String(file?.mime || file?.type || "");
  if (mime.startsWith("image/")) return { key: "image", label: "Immagine" };
  if (mime === "application/pdf" || name.endsWith(".pdf")) return { key: "pdf", label: "PDF" };
  if (/\.(docx?|odt|rtf)$/.test(name)) return { key: "doc", label: "Documento" };
  if (/\.(xlsx?|ods|csv)$/.test(name)) return { key: "sheet", label: "Foglio" };
  return { key: "file", label: "File" };
}
